import type { Integration } from '@cosuno/analytics-frontend';
import { pick } from 'lodash';
import { useCallback, useMemo } from 'react';

import { env } from '../../todo';
import { storeEventForCypress } from './utils';

const settings = {
  useRawEventFormat: true,
  ignoreTrackingEnabledStatus: true,
} satisfies Integration['settings'];

const useCypressIntegration = (): Integration => {
  const identifyUser = useCallback<NonNullable<Integration['identifyUser']>>(({ commonData }) => {
    storeEventForCypress({
      name: 'identify',
      props: {
        userId: commonData.id,
        userInfo: pick(commonData, [
          'firstName',
          'lastName',
          'email',
          'company',
          'type',
          'language',
        ]),
      },
    });
  }, []);

  const trackPageView = useCallback<NonNullable<Integration['trackPageView']>>((eventProps) => {
    storeEventForCypress({
      name: 'pageView',
      props: { ...eventProps },
    });
  }, []);

  const trackEvent = useCallback<NonNullable<Integration['trackEvent']>>(
    (eventName, eventProps) => {
      storeEventForCypress({
        name: eventName,
        props: eventProps,
      });
    },
    [],
  );

  return useMemo(
    () => ({
      name: 'cypress',
      enabled: env.REACT_APP_CYPRESS === 'true',
      initialize: () => {},
      trackEvent,
      trackPageView,
      identifyUser,
      settings,
    }),
    [identifyUser, trackEvent, trackPageView],
  );
};

export default useCypressIntegration;
